import type { Theme } from '@mui/material';
import type { TreeViewBaseItem } from '@mui/x-tree-view/models';

import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { Box, Stack, Skeleton, Typography, useMediaQuery } from '@mui/material';

import { settingsFunc } from 'src/context/settings/settings';

import { Scrollbar } from 'src/components/scrollbar';

export const CategoryFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const settings = useSelector((state: any) => state.settings);
  const [categoriesData, setCategoriesData] = useState([] as TreeViewBaseItem[]);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(props.filters.listing?.category);

  useEffect(() => {
    if (dispatch) {
      dispatch(settingsFunc());
    }
  }, [dispatch]);

  useEffect(() => {
    const settingsData = settings?.settingsData;

    if (settingsData && settingsData.length > 0) {
      const categories = settingsData[4].categories.map((category: any, index: number) => ({
        id: settingsData[4]._id + index,
        label: category._id,
      }));

      setCategoriesData(categories);
    }
  }, [settings]);

  useEffect(() => {
    setSelectedCategory(props.filters.listing?.category);
  }, [props.filters.listing?.category]);

  const handleCategorySelect = (event: React.MouseEvent, itemId: string) => {
    const selectedItem = categoriesData.find((item) => item.id === itemId);
    if (selectedItem) {
      const newFilters = {
        ...props.filters,
        listing: {
          ...props.filters.listing,
          category: selectedItem.label,
        },
      };
      props.setFilters(newFilters);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Kategoriler
      </Typography>

      <Scrollbar sx={{ maxHeight: 164 }}>
        {settings.settingsLoading ? (
          <Stack spacing={2}>
            <Skeleton variant="rectangular" sx={{ width: '100%', height: 16 }} />
            <Skeleton variant="rectangular" sx={{ width: '100%', height: 16 }} />
            <Skeleton variant="rectangular" sx={{ width: '100%', height: 16 }} />
          </Stack>
        ) : (
          <RichTreeView
            items={categoriesData}
            onItemClick={handleCategorySelect}
            sx={{
              '& .MuiTreeItem-content .MuiTreeItem-label': {
                fontFamily: 'Rubik, sans-serif',
                fontWeight: 400,
                color: '#333333BF',
              },
            }}
          />
        )}
      </Scrollbar>
    </Box>
  );
};
